<template>
  <MRadioGroup
    :value="value"
    :options="scopeOptions"
    :disabled="disabled"
    @change="$emit('change', $event)"
  />
</template>
<script>
import { scopeOptions } from '@modules/asset/helpers/option-map'
export default {
  name: 'ScopeRadioGroup',
  model: { event: 'change' },
  props: {
    value: { type: String, default: 'global_access' },
    disabled: { type: Boolean, default: false },
    hasCustomScope: { type: Boolean, default: false },
  },
  data() {
    this.scopeOptions = scopeOptions()
      .filter((option) => {
        if (!this.hasCustomScope) {
          return option.key !== 'custom_scope'
        }
        return true
      })
      .map((option) => ({ ...option, value: option.key }))
    return {}
  },
}
</script>
